import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer';
import { ITab, ITabs } from 'src/common/interfaces/dtos/ITabs';
import { checkAndGetArray } from '../../helpers/array-helper';

export interface ICommandMenuItem {
  key: string;
  description: string;
}

export interface ITabMenuState {
  defaultTabs: ITab[];
  saleTabs: ITab[];
  returnTabs: ITab[];
  rawTabs: ITabs;
}

const initialState: ITabMenuState = {
  defaultTabs: [],
  saleTabs: [],
  returnTabs: [],
  rawTabs: {},
};

class TabMenuReducer extends ImmerReducer<ITabMenuState> {
  public setTabs(tabs: ITabs): void {
    this.draftState.rawTabs = tabs;
    this.draftState.defaultTabs = this.getTabList('DefaultTabGroup', tabs);
    this.draftState.saleTabs = this.getTabList('ActiveSaleTabGroup', tabs);
    this.draftState.returnTabs = this.getTabList('ReturnsTabGroup', tabs);
  }

  private getTabList(tabGroupName: string, tabs: ITabs): ITab[] {
    let tabConfig: ITab[] = [];
    if (tabs[tabGroupName] && tabs[tabGroupName].tabs) {
      tabConfig = checkAndGetArray(tabs[tabGroupName].tabs);
      return tabConfig;
    }

    return [];
  }
}

export const TabMenuActions = createActionCreators(TabMenuReducer);
export const TabMenuReducerFunction = createReducerFunction(TabMenuReducer, initialState);
